import React, { useEffect, useState, useCallback, memo, useRef } from "react";
import {
	GoogleMap,
	useJsApiLoader,
	useLoadScript,
	InfoWindow,
	Marker,
	MarkerClusterer,
	OverlayView,
} from "@react-google-maps/api";
import DashMapDownload from "./DashMapDownload";
import LampDataService from "../../apis/lamps-data";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Polyline } from "@react-google-maps/api";
import {
	MuiThemeProvider,
	createMuiTheme,
	makeStyles,
	createStyles,
} from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
// import { MarkerClusterer } from "@react-google-maps/marker-clusterer";

import {
	deviceErrorEventCode,
	deviceErrorCodes,
	deviceStatusCode,
	devicePhaseCode,
} from "../../constants/constants";
import redBulbImg from "../../assets/images/red-bulb.png";
import mapRedImg from "../../assets/images/map-icon-input-red.svg";
import mapAmberImg from "../../assets/images/map-icon-amber.svg";
import mapBlueImg from "../../assets/images/map-icon-blue.svg";
import mapGreenImg from "../../assets/images/map-icon-green.svg";
import mapGrayImg from "../../assets/images/map-icon-gray.svg";
import mapStreetLightOn from "../../assets/images/ico-street-light-on.png";


import mapStreetLightOff from "../../assets/images/ico-street-light-off.png";
import mapStreetLightPink from "../../assets/images/ico-lamp-pink.png";
import mapStreetLightOrange from "../../assets/images/ico-lamp-orange.png";
import mapStreetLightGreen from "../../assets/images/ico-lamp-green.png";
import mapStreetLightBlue from "../../assets/images/ico-lamp-blue.png";

import mapStreetLightTriangle from "../../assets/images/ico-lamp-triangle.png";
import mapStreetLightCircle from "../../assets/images/ico-lamp-circle.png";
import mapStreetLightDiamond from "../../assets/images/ico-lamp-diamond.png";
import mapStreetLightSquare from "../../assets/images/ico-lamp-square.png";

import mapStreetLightTriangleShaded from "../../assets/images/ico-lamp-triangle-shaded.png";
import mapStreetLightCircleShaded from "../../assets/images/ico-lamp-circle-shaded.png";
import mapStreetLightDiamondShaded from "../../assets/images/ico-lamp-diamond-shaded.png";
import mapStreetLightSquareShaded from "../../assets/images/ico-lamp-square-shaded.png";

import icPoleSLCOffLamp0 from "../../assets/images/ico-pole-slc0-lamp0.png";
import icPoleSLCOnLamp0 from "../../assets/images/ico-pole-slc1-lamp0.png";
import icPoleLamp0 from "../../assets/images/ico-pole-lamp0.png";
import icPoleLamp1 from "../../assets/images/ico-pole-lamp1.png";
import icPoleLamp2 from "../../assets/images/ico-pole-lamp2.png";
import icPoleLamp3 from "../../assets/images/ico-pole-lamp3.png";
import icPoleLamp4 from "../../assets/images/ico-pole-lamp4.png";

import icPoleLampOn0 from "../../assets/images/ico-pole-lamp0.png";
import icPoleLampOn1 from "../../assets/images/ico-pole-lampOn1.png";
import icPoleLampOn2 from "../../assets/images/ico-pole-lampOn2.png";
import icPoleLampOn3 from "../../assets/images/ico-pole-lampOn3.png";
import icPoleLampOn4 from "../../assets/images/ico-pole-lampOn4.png";

import icPoleLampOff0 from "../../assets/images/ico-pole-lamp0.png";
import icPoleLampOff1 from "../../assets/images/ico-pole-lampOff1.png";
import icPoleLampOff2 from "../../assets/images/ico-pole-lampOff2.png";
import icPoleLampOff3 from "../../assets/images/ico-pole-lampOff3.png";
import icPoleLampOff4 from "../../assets/images/ico-pole-lampOff4.png";

import icPoleLamp0Off from "../../assets/images/ico-pole-lamp0-off.png"
import icPoleLamp1Off from "../../assets/images/ico-pole-lamp1-off.png";
import icPoleLamp2Off from "../../assets/images/ico-pole-lamp2-off.png";
import icPoleLamp3Off from "../../assets/images/ico-pole-lamp3-off.png";
import icPoleLamp4Off from "../../assets/images/ico-pole-lamp4-off.png";

import ilmOn from "../../assets/images/ilmOn.png";
import ilmOff from "../../assets/images/ilmOff.png";

import icPoleLamp0On from "../../assets/images/ico-pole-lamp0-on.png";
import icPoleLamp1On from "../../assets/images/ico-pole-lamp1-on.png";
import icPoleLamp2On from "../../assets/images/ico-pole-lamp2-on.png";
import icPoleLamp3On from "../../assets/images/ico-pole-lamp3-on.png";
import icPoleLamp4On from "../../assets/images/ico-pole-lamp4-on.png";

import DeviceDataService from "../../apis/device-data";

import PoleDataService from "../../apis/pole-data";
import "../../styles/dashboard.scss";
import { FormControl, FormControlLabel, FormGroup, InputLabel, MenuItem, Select, Switch } from "@material-ui/core";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import axios from "axios";
import * as dev_constants from '../../constants/dev_constants';
import { checkUserAccess } from "../../apis/auth";

import { updatePoles } from "../../query/pole.query";
import { getSLCLine, updateSLCLine } from "../../query/slc-line.query";
import { NotificationManager } from "react-notifications";
import { GeoPoint } from "firebase/firestore";

const useStyles = makeStyles((theme) =>
	createStyles({
		formControl: {
			minWidth: 130,
			marginBottom: 20,
			marginRight: 20,
			height: "30px", // Set a specific height
			padding: "5px", // Optional: Adjust padding to reduce content space
		},
	})
);


const containerStyle = {

	width: "100%",
	height: "300px",
};


const GOOGLE_MAP_CONFIG = {
	//   apiKey: "AIzaSyAuCpOhLsnn5cLRvW3il_f_2Tb6mJ03eEU",
	// apiKey: "AIzaSyAn4guV9udrnZ0WVfxXWEr4ClB16ho2E",
	// apiKey: "AIzaSyA3YwoIVmgjMg0bCROj-ICuDiysP3r3XqE",
	apiKey: "AIzaSyAgpuvCWt4jbFoC7zjgl7MgwZBOg4zafUU",
	center: {
		lat: 10.95069,
		lng: 76.95634,
	},
	zoom: 15,
};

function generateStaticMapURL(params) {
	// Define the base URL for Google Static Maps API
	const baseURL = "https://maps.googleapis.com/maps/api/staticmap?";

	// Initialize an array to store query parameters
	const queryParams = [];

	// Add required parameters
	queryParams.push(`size=${params.size || "480x480"}`);
	queryParams.push(`key=${params.apiKey || 'AIzaSyAgpuvCWt4jbFoC7zjgl7MgwZBOg4zafUU'}`); // Replace with your own API key

	// Add optional parameters
	// Add the center location
	if (params.center.trim().length > 0) {
		queryParams.push(`center=${encodeURIComponent(params.center)}`);
	}

	if (params.zoom.trim().length > 0) {
		queryParams.push(`zoom=${params.zoom}`);
	}

	if (params.markers?.length) {
		for (const marker of params.markers) {
			queryParams.push(`markers=${encodeURIComponent(marker)}`);
		}
	}

	if (params.mapType.trim().length > 0) {
		queryParams.push(`maptype=${params.mapType}`);
	}

	if (params.scale.trim().length > 0) {
		queryParams.push(`scale=${params.scale}`);
	}

	if (params.path.trim().length > 0) {
		queryParams.push(`path=${encodeURIComponent(params.path)}`);
	}

	if (params.visible.trim().length > 0) {
		queryParams.push(`visible=${encodeURIComponent(params.visible)}`);
	}

	// Construct the final URL by joining all query parameters
	return `${baseURL}${queryParams.join("&")}`;
}

const DashGoogleMap = ({ data = [] }) => {

	const history = useHistory();
	const classes = useStyles();
	const { isLoaded } = useLoadScript({
		id: "google-map-script",
		googleMapsApiKey: `https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${GOOGLE_MAP_CONFIG.apiKey}`,
	});

	const mapRef = React.useRef();
	const [map, setMap] = useState(null);
	const [center, setCenter] = useState({
		...GOOGLE_MAP_CONFIG.center,
	});
	const [activeMarker, setActiveMarker] = useState(null);
	// const [activeLamps, setActiveLamps] = useState([]);
	const [activePoles, setActivePoles] = useState([]);
	const [activeIlm, setActiveIlms] = useState([]);
	const [toggleMap, setToggleMap] = useState(true);
	const [dataCount, setDataCount] = useState(0);
	const [showWatts, setShowWatts] = useState(false);
	const [refresh, setRefresh] = useState(false);
	const slcLine = useRef({});
	const contentRef = useRef();
	const [imageUrl, setImageUrl] = useState('');
	const drawFlag = useRef(false);
	const eraseFlag = useRef(false);
 	const popupFlag = useRef(true);
	const moveLampFlag = useRef(false);
	const moveMarkerFlag = useRef(false);
	const poleWatts = useRef([]);
	const [infoWindowFlag, setInfoWindowFlag] = useState(null);
	const [ilmInfoWindowFlag, setIlmInfoWindowFlag] = useState(null);
	const errorData = [""];



	// const [poleMarkerPosition, setPoleMarkerPosition] = useState({});
	const poleMarkerPosition = useRef({});
	const [MarkerPosition, setMarkerPosition] = useState({});

	useEffect(async () => {
		console.log("=====> Data dount update");
		if (map != null) {
			console.log("=====> Data dount update map available");
			updateMapBounds(map, data);
			// const bounds = new window.google.maps.LatLngBounds();
			// data.forEach((mItem) => {
			// let lat = 0;
			// let lng = 0;
			// let pole = null;
			// const { loc: { _lat: devLat = 0, _long: devLng = 0 } = {} } = mItem || {};
			// if (mItem.pid != undefined && mItem.pid != null) {
			//   pole = PoleDataService.getInstance().getPole(mItem.pid);
			// }

			// if (pole != null && pole.loc != undefined && pole.loc != null) {
			//   const {
			//     loc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {}
			//   } = pole;
			//   lat = latitudeVal;
			//   lng = longitudeVal;
			// } else {
			//   lat = devLat;
			//   lng = devLng;
			// }
			//   if (lat == 0 && lng == 0) {
			//     return;
			//   }
			//   const position = {
			//     lat,
			//     lng,
			//   };
			//   return bounds.extend(position);
			// });
			// map.fitBounds(bounds);
		} else {
			console.log("=====> Data dount update no map");
		}
	}, [dataCount]);


	useEffect(async () => {
		setTimeout(() => {
			setDataCount((preVal) => {
				return preVal + 1
			});
		}, 1000);

		if (filterObj === 'ilm') {
			var ilmData = LampDataService.getInstance().getAllLamp();
			setActiveIlms(ilmData.ilmList)
		}

	}, [data]);

	const handleShowWattsChange = (event) => {
		setShowWatts(event.target.checked);
	};

	const handleButtonClick = () => {

		const url = `/slc-print?data=${activeMarker}`;
		const navigate = window.open(url, '_blank');
		//const navigate = window.open(url, 'newwindow', 'width=800,height=800');
		navigate.focus();

	};

	const handleToggleMap = () => {
		setToggleMap((prevState) => !prevState);
	};

	const handleActiveMarker = async (marker) => {
		if (marker === activeMarker) {
			return;
		}
		setActiveMarker(marker);
		// getPolesBySLC
		if (marker != null || marker != undefined) {
			var poles = PoleDataService.getInstance().getPolesBySLC(marker);
			setActivePoles(poles);
		}
		updateMapBoundsByPoles(map, poles);
		var slcLineData = await getSLCLine(marker);
		if (slcLineData != undefined && slcLineData != null && Object.keys(slcLineData).length > 0) {
			slcLine.current = slcLineData;
		}
		setRefresh((data) => { return !data; });

	};

	const resetActiveMarker = async () => {

		slcLine.current = {};
		setActiveMarker(null);
		// setIlmInfoWindowFlag('')
		// setActiveLamps([]);
		setActivePoles([]);
		updateMapBounds(map, data);
		setShowWatts(false);
		// setPoleMarkerPosition({});
		poleMarkerPosition.current = {};

	};
	// const pathCoordinates = [];

	// const [path, setPath] = useState(pathCoordinates);

	const onMapClick = (e) => {

		const position = {
			lat: e.latLng.lat(),
			lng: e.latLng.lng(),
		};

		drawMap(position);



	}

	const drawMap = (data) => {

		if (drawFlag.current == true) {

			var newItem = {
				"lat": data.lat,
				"lng": data.lng
			};
			//  console.log(newItem);

			var path = slcLine.current?.data?.path;
			if (path != undefined && path != null) {
				// Clone the outer array
				const newOuterArray = [...path];
				// Get the last outer array index
				const lastOuterIndex = newOuterArray.length - 1;
				// Clone the last inner array
				const lastInnerArray = [...newOuterArray[lastOuterIndex]];
				// Append the new item to the last inner array
				lastInnerArray.push(newItem);
				// Update the last inner array in the outer array
				newOuterArray[lastOuterIndex] = lastInnerArray;
				// Return the updated array as the new state
				slcLine.current.data.path = newOuterArray;
			}
			slcLine.current.data.slc_id = activeMarker;
			setRefresh((data) => { return !data; });

			// setPath(prevPath => {
			// 	// Clone the outer array
			// 	const newOuterArray = [...prevPath];
			// 	// Get the last outer array index
			// 	const lastOuterIndex = newOuterArray.length - 1;
			// 	// Clone the last inner array
			// 	const lastInnerArray = [...newOuterArray[lastOuterIndex]];
			// 	// Append the new item to the last inner array
			// 	lastInnerArray.push(newItem);
			// 	// Update the last inner array in the outer array
			// 	newOuterArray[lastOuterIndex] = lastInnerArray;
			// 	// Return the updated array as the new state
			// 	return newOuterArray;
			// });
		}
	}

	const createAlertMessage = (message, isSuccess = true) => {
		// Create the alert div
		const alertMsgDiv = document.createElement('div');

		// Create check icon element
		const iconDiv = document.createElement('div');
		iconDiv.innerHTML = isSuccess ? '✓' : '<span style="font-weight: bold; font-size: 15px;">✕</span>';
		iconDiv.style.marginRight = '10px';
		iconDiv.style.fontSize = '20px';
		iconDiv.style.display = 'flex';
		iconDiv.style.alignItems = 'center';

		// Create text element
		const textDiv = document.createElement('div');
		textDiv.textContent = message;

		// Add icon and text to alert div
		alertMsgDiv.appendChild(iconDiv);
		alertMsgDiv.appendChild(textDiv);

		// Apply styles to match your screenshot
		alertMsgDiv.style.marginTop = '10px';
		alertMsgDiv.style.backgroundColor = isSuccess ? '#4CAF50' : '#f44336'; // Green for success, red for error
		alertMsgDiv.style.color = 'white';
		alertMsgDiv.style.width = 'auto';
		alertMsgDiv.style.minWidth = '220px';
		alertMsgDiv.style.marginRight = "5px";
		alertMsgDiv.style.padding = '10px';
		alertMsgDiv.style.height = '20px';
		alertMsgDiv.style.borderRadius = '5px';
		alertMsgDiv.style.fontFamily = 'Arial, sans-serif';
		alertMsgDiv.style.cursor = 'pointer';

		// Center text inside the div
		alertMsgDiv.style.display = 'flex';
		alertMsgDiv.style.alignItems = 'center';
		alertMsgDiv.style.justifyContent = 'flex-start';
		alertMsgDiv.style.textAlign = 'left';
		alertMsgDiv.style.fontSize = '14px';

		return alertMsgDiv;
	};


	const popUpMenu = (map, dev_id, errors, ward, zone, ccmsNumber) => {

		const popupDiv = document.createElement('div');
		const uidDiv = document.createElement('div');
		const statusDiv = document.createElement('div');
		const errorDiv = document.createElement('div');
		const wardDiv = document.createElement('div');
		const zoneDiv = document.createElement('div');
		const saveButton = document.createElement('Button');
		const closeButton = document.createElement('Button')
		closeButton.textContent = "✕";
		closeButton.style.float = "right";

		closeButton.style.backgroundColor = 'white';
		closeButton.style.border = '1px solid white';
		///Outer layout
		popupDiv.style.marginRight = "10px";
		popupDiv.style.marginTop = "10px";
		//popupDiv.style.height = '60px';
		popupDiv.style.width = '180px';
		popupDiv.style.backgroundColor = 'white';
		popupDiv.style.padding = '10px';
		popupDiv.style.border = '1px solid white';
		popupDiv.style.boxShadow = '0px 0px 10px rgba(0,0,0,0.1)';

		errors?.map((errCode) => {
			errorData.push(deviceErrorEventCode[errCode]);
		})

		uidDiv.textContent = "UID : " + dev_id;
		statusDiv.textContent = "Status : " + getDeviceStatus(ccmsNumber);
		var err = errorData.join();


		errorDiv.textContent = "Error : " + err.substring(1, err.length);
		wardDiv.textContent = "Ward :" + ward;
		zoneDiv.textContent = "Zone :" + zone



		// Div.appendChild(closeButton);
		popupDiv.appendChild(closeButton);
		popupDiv.appendChild(uidDiv);
		popupDiv.appendChild(statusDiv);
		if (errors.length != 0) {
			popupDiv.appendChild(errorDiv);
		}
		popupDiv.appendChild(zoneDiv)
		popupDiv.appendChild(wardDiv)


		const buttonDiv = document.createElement('div');
		const drawButton = document.createElement('Button');
		const eraseButton = document.createElement('Button');
		const moveLampButton = document.createElement('Button');

		buttonDiv.style.marginRight = "10px";
		buttonDiv.style.marginTop = "10px";

		moveLampButton.textContent = 'Move';
		moveLampButton.style.height = '40px';
		moveLampButton.style.width = '100px';
		moveLampButton.style.backgroundColor = 'white';
		moveLampButton.style.padding = '10px';
		moveLampButton.style.te = 'center';
		moveLampButton.style.border = '1px solid white';
		moveLampButton.style.boxShadow = '0px 0px 10px rgba(0,0,0,0.1)';

		//Set id for popupDiv and buttonDiv
		popupDiv.id = 'popupDiv';
		popupDiv.id = 'buttonDiv';



		drawButton.textContent = 'Draw';
		drawButton.style.height = '40px';
		drawButton.style.width = '80px';
		drawButton.style.backgroundColor = 'white';
		drawButton.style.padding = '10px';
		drawButton.style.border = '1px solid white';
		drawButton.style.boxShadow = '0px 0px 10px rgba(0,0,0,0.1)';

		saveButton.textContent = 'Save';
		saveButton.style.height = '40px';
		saveButton.style.backgroundColor = 'white';
		saveButton.style.padding = '10px';
		saveButton.style.border = '1px solid white';
		saveButton.style.boxShadow = '0px 0px 10px rgba(0,0,0,0.1)';

		eraseButton.textContent = 'Erase';
		eraseButton.style.top = '20px';
		eraseButton.style.height = '40px';
		eraseButton.style.width = '100px';
		eraseButton.style.backgroundColor = 'white';
		eraseButton.style.padding = '10px';
		eraseButton.style.border = '1px solid white';
		eraseButton.style.boxShadow = '0px 0px 10px rgba(0,0,0,0.1)';

		moveLampButton.addEventListener('click', () => {

			if (moveLampFlag.current == false) {
				moveLampFlag.current = true;
				moveMarkerFlag.current = true;
				moveLampButton.textContent = "Stop";
			}
			else {
				moveLampButton.textContent = "Move";
				moveLampFlag.current = false;
				moveMarkerFlag.current = false;

			}
			setRefresh((data) => { return !data; });
		});

		drawButton.addEventListener('click', () => {
			drawButton.textContent = drawFlag.current == true ? "Draw   " : "Undraw";
			eraseButton.textContent = "Erase";

			eraseFlag.current = false;
			//drawFlag.current == true ? drawFlag.current = false : drawFlag.current = true , setPath((current)=> [...current, []]);
			if (drawFlag.current == true) {
				drawFlag.current = false;
			}
			else {
				drawFlag.current = true
				var path = slcLine.current?.data?.path;
				if (path === undefined || path === null) {
					slcLine.current = slcLine.current ?? {};
					slcLine.current.data = slcLine.current.data ?? {};
					slcLine.current.data.path = slcLine.current.data.path ?? [];
				}
				slcLine.current.data.path.push([]);
				// setPath((current) => [...current, []]); 
			}
			setRefresh((data) => { return !data; });

		});


		eraseButton.addEventListener('click', () => {

			eraseButton.textContent = eraseFlag.current == true ? "Erase  " : "Non Erase";
			drawButton.textContent = "Draw";
			drawFlag.current = false;

			if (eraseFlag.current == true) {
				eraseFlag.current = false
			}
			else {
				eraseFlag.current = true
			}
			setRefresh((data) => { return !data; });
		});

		closeButton.addEventListener("click", () => {
			map.controls[window.google.maps.ControlPosition.BLOCK_START_INLINE_END].pop(popupDiv);
			if (checkUserAccess("map_update"))
				map.controls[window.google.maps.ControlPosition.BLOCK_START_INLINE_END].pop(buttonDiv);
			popupFlag.current = true;
			popupFlag.current = true;
			setIlmInfoWindowFlag('')
			setInfoWindowFlag('')
			resetActiveMarker();
		});


		saveButton.addEventListener("click", async () => {

			drawButton.textContent = "Draw";
			eraseButton.textContent = "Erase";
			drawFlag.current = false;

			var updatedPoles = {};
			for (var key in poleMarkerPosition.current) {
				var polePos = poleMarkerPosition.current[key];
				var poleRef = PoleDataService.getInstance().getPoleDocId(key);

				// updatedPoles[poleRef] = {loc: { _lat: polePos.lat, _long: polePos.lng}};
				updatedPoles[poleRef] = { loc: new GeoPoint(polePos.lat, polePos.lng) };
			}
			var status = true;
			debugger;
			if (Object.keys(updatedPoles).length > 0) {
				await updatePoles(updatedPoles).then((result) => {
					// setPoleMarkerPosition({});
					poleMarkerPosition.current = {};
				}).catch((e) => {
					// NotificationManager.error("Failed to save changes.", "", 3000);
					// return;
					status = false;
				});


			}

			await updateSLCLine(slcLine.current).then((result) => {
			}).catch((e) => {
				// NotificationManager.error("Failed to save changes.", "", 3000);
				// return;
				status = false;
			});

			if (status == true) {
				map.controls[window.google.maps.ControlPosition.TOP_LEFT].push(createAlertMessage("Changes updated successfully", true));
				setTimeout(() => {
					map.controls[window.google.maps.ControlPosition.TOP_LEFT].pop(createAlertMessage("Changes updated successfully", true));
				}, [3000])

				// NotificationManager.success("Changes updated successfully", "", 3000);
			} else {
				// NotificationManager.error("Failed to save changes.", "", 3000);
				map.controls[window.google.maps.ControlPosition.TOP_LEFT].push(createAlertMessage("Failed to save changes", false));
				setTimeout(() => {
					map.controls[window.google.maps.ControlPosition.TOP_LEFT].pop(createAlertMessage("Failed to save changes", false));
				}, [3000])

			}

		});

		//popupDiv.appendChild(infoWindow);
		buttonDiv.appendChild(moveLampButton);
		buttonDiv.appendChild(drawButton);
		buttonDiv.appendChild(eraseButton);
		buttonDiv.appendChild(saveButton)

		// buttonDiv.appendChild(alertMsgDiv)

		if (checkUserAccess("map_update")) {
			map.controls[window.google.maps.ControlPosition.BLOCK_START_INLINE_END].push(buttonDiv);
		}
		map.controls[window.google.maps.ControlPosition.BLOCK_START_INLINE_END].push(popupDiv);

	}




	const onLoad = useCallback(function callback(mapArg) {
		// const bounds = new window.google.maps.LatLngBounds();
		// data.forEach((mItem) => {
		//   let lat = 0;
		//   let lng = 0;
		//   let pole = null;
		//   const { loc: { _lat: devLat = 0, _long: devLng = 0 } = {} } = mItem || {};
		//   if (mItem.pid != undefined && mItem.pid != null) {
		//     pole = PoleDataService.getInstance().getPole(mItem.pid);
		//   }

		//   if (pole != null && pole.loc != undefined && pole.loc != null) {
		//     const {
		//       loc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {}
		//     } = pole;
		//     lat = latitudeVal;
		//     lng = longitudeVal;
		//   } else {
		//     lat = devLat;
		//     lng = devLng;
		//   }
		//   const position = {
		//     lat,
		//     lng,
		//   };
		//   // debugger;
		//   return bounds.extend(position);
		// });
		// mapArg.fitBounds(bounds);
		updateMapBounds(mapArg, data);
		setMap(mapArg);


	}, []);

	const updateMapBounds = (googleMap, items) => {
		const bounds = new window.google.maps.LatLngBounds();
		items.forEach((mItem) => {
			let lat = 0;
			let lng = 0;
			let pole = null;
			const { loc: { _lat: devLat = 0, _long: devLng = 0 } = {} } = mItem || {};
			if (mItem.pid != undefined && mItem.pid != null) {

				pole = PoleDataService.getInstance().getPole(mItem.pid);
			}

			if (pole != null && pole.loc != undefined && pole.loc != null) {
				const {
					loc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {}
				} = pole;
				lat = latitudeVal;
				lng = longitudeVal;
			} else {
				lat = devLat;
				lng = devLng;
			}
			const position = {
				lat,
				lng,
			};
			if (lat == 0 && lng == 0) {
				return;
			}
			return bounds.extend(position);
		});
		googleMap.fitBounds(bounds);
	}

	const updateMapBoundsByPoles = (googleMap, poles) => {
		const bounds = new window.google.maps.LatLngBounds();
		poles.forEach((pole) => {
			let lat = 0;
			let lng = 0;

			if (pole != null && pole.loc != undefined && pole.loc != null) {
				const {
					loc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {}
				} = pole;
				lat = latitudeVal;
				lng = longitudeVal;
			}
			const position = {
				lat,
				lng,
			};
			if (lat == 0 && lng == 0) {
				return;
			}
			return bounds.extend(position);
		});
		googleMap.fitBounds(bounds);
	}

	const onZoomChanged = () => {
		if (map != null) {
			console.log(`Zoom changed ${map.getZoom()}`);
			// if (activeMarker != null && activeMarker != "") {
			// 	downloadMap(activeMarker, activeLamps, map.getZoom().toString());
			// }
		}
	};

	const onUnmount = React.useCallback(function callback(map) {
		setMap(null);
	}, []);

	const getDeviceStatus = (devId) => {
		var mapItem = data.find((item) => item.uid == devId);
 		if (mapItem != null && DeviceDataService.getInstance().getSlcCountStatus(mapItem) == dev_constants.DeviceStatusOn) {
			//if (DeviceDataService.getInstance().isDeviceIdOn(devId)) {
			return deviceStatusCode[1];
		} else {
			return deviceStatusCode[2];
		}
	};

	const getMapImage = (ccmsItem) => {
		const { err_cnt = 0, errors = [], dev_st = 0, dev_id = "" } = ccmsItem || {};
		var mapItem = data.find((item) => item.dev_id == dev_id);
		if (mapItem != null && DeviceDataService.getInstance().getSlcCountStatus(mapItem) == dev_constants.DeviceStatusOn) {
			// if (DeviceDataService.getInstance().isDeviceIdOn(dev_id)) {
			return mapGreenImg;
		} else {
			return mapRedImg;
		}
	};

	// const getLampImage = (lamp) => {
	// 	const { dev_st: statusCode = 0, wt: wt = 0, lgt: lgt = false } = lamp || {};
	// 	if (showWatts) {
	// 		if (wt > 0 && wt <= 20) {
	// 			// return mapStreetLightPink;
	// 			return lgt ? mapStreetLightTriangleShaded : mapStreetLightTriangle;
	// 		} else if (wt <= 70) {
	// 			// return mapStreetLightOrange;
	// 			return lgt ? mapStreetLightCircleShaded : mapStreetLightCircle;
	// 		} else if (wt > 70 /*120 /*wt <= 120*/) {
	// 			// return mapStreetLightGreen;
	// 			return lgt ? mapStreetLightDiamondShaded : mapStreetLightDiamond;
	// 		} else {
	// 			// return mapStreetLightBlue
	// 			return lgt ? mapStreetLightSquareShaded : mapStreetLightSquare;
	// 		}

	// 	} else {
	// 		if (statusCode === 1) {
	// 			return mapStreetLightOn;
	// 		} else {
	// 			return mapStreetLightOff;
	// 		}
	// 	}
	// };

	const getPoleImage = (pole) => {
		// debugger;
		var poleImage = icPoleLamp1;
		const { slc_id: slc_id, nfix: nfix = 0, is_slc: is_slc = false, dmy: dmy = false } = pole || {};
		const device = LampDataService.getInstance().getLampByPid(pole['uid']); //get lapm watts 
		const { dev_st: poleStatus } = device || {};
		if (is_slc) {
			var status = DeviceDataService.getInstance().isDeviceIdOn(slc_id);
			if (status == true) {
				/// SLC is on
				if (nfix === 0) {
					poleImage = icPoleLamp0On;///Green pole no lamp
				} else if (nfix === 1) {
					poleImage = icPoleLamp1On;///Green pole 1 lamp
				} else if (nfix === 2) {
					poleImage = icPoleLamp2On;///Green pole 2 lamp
				} else if (nfix === 3) {
					poleImage = icPoleLamp3On;///Green pole 3 lamp
				} else if (nfix > 3) {
					poleImage = icPoleLamp4On;///Green pole 4 lamp
				}
			} else {
				/// SLC is off
				if (nfix === 0) {
					poleImage = icPoleLamp0Off;///Red pole no lamp
				} else if (nfix === 1) {
					poleImage = icPoleLamp1Off;///Red pole 1 lamp
				} else if (nfix === 2) {
					poleImage = icPoleLamp2Off;///Red pole 2 lamp
				} else if (nfix === 3) {
					poleImage = icPoleLamp3Off;///Red pole 3 lamp
				} else if (nfix > 3) {
					poleImage = icPoleLamp4Off;///Red pole 4 lamp
				}
			}
		} else {
			if (poleStatus === 1) {
				if (nfix === 0) {
					poleImage = icPoleLampOn0;///pole no lamp
				} else if (nfix === 1) {
					poleImage = icPoleLampOn1;///pole 1 lamp
				} else if (nfix === 2) {
					poleImage = icPoleLampOn2;///pole 2 lamp
				} else if (nfix === 3) {
					poleImage = icPoleLampOn3;///pole 3 lamp
				} else if (nfix > 3) {
					poleImage = icPoleLampOn4;///pole 4 lamp
				}
			} else if (poleStatus === 2) {
				if (nfix === 0) {
					poleImage = icPoleLampOff0;///pole no lamp
				} else if (nfix === 1) {
					poleImage = icPoleLampOff1;///pole 1 lamp
				} else if (nfix === 2) {
					poleImage = icPoleLampOff2;///pole 2 lamp
				} else if (nfix === 3) {
					poleImage = icPoleLampOff3;///pole 3 lamp
				} else if (nfix > 3) {
					poleImage = icPoleLampOff4;///pole 4 lamp
				}
			} else {
				if (nfix === 0) {
					poleImage = icPoleLampOff0;///pole no lamp
				} else if (nfix === 1) {
					poleImage = icPoleLampOff1;///pole 1 lamp
				} else if (nfix === 2) {
					poleImage = icPoleLampOff2;///pole 2 lamp
				} else if (nfix === 3) {
					poleImage = icPoleLampOff3;///pole 3 lamp
				} else if (nfix > 3) {
					poleImage = icPoleLampOff4;///pole 4 lamp
				}
			}

		}
		return poleImage;

		// var poleImage = icPoleLamp1;
		// const { slc_id: slc_id, nfix: nfix = 0, is_slc: is_slc = false, dmy: dmy = false } = pole || {};
		// if (is_slc) {
		// 	var status = DeviceDataService.getInstance().isDeviceIdOn(slc_id);
		// 	if (status == true) {
		// 		/// SLC is on
		// 		if (nfix === 0) {
		// 			poleImage = icPoleLamp0On;///Green pole no lamp
		// 		} else if (nfix === 1) {
		// 			poleImage = icPoleLamp1On;///Green pole 1 lamp
		// 		} else if (nfix === 2) {
		// 			poleImage = icPoleLamp2On;///Green pole 2 lamp
		// 		} else if (nfix === 3) {
		// 			poleImage = icPoleLamp3On;///Green pole 3 lamp
		// 		} else if (nfix > 3) {
		// 			poleImage = icPoleLamp4On;///Green pole 4 lamp
		// 		}
		// 	} else {
		// 		/// SLC is off
		// 		if (nfix === 0) {
		// 			poleImage = icPoleLamp0Off;///Red pole no lamp
		// 		} else if (nfix === 1) {
		// 			poleImage = icPoleLamp1Off;///Red pole 1 lamp
		// 		} else if (nfix === 2) {
		// 			poleImage = icPoleLamp2Off;///Red pole 2 lamp
		// 		} else if (nfix === 3) {
		// 			poleImage = icPoleLamp3Off;///Red pole 3 lamp
		// 		} else if (nfix > 3) {
		// 			poleImage = icPoleLamp4Off;///Red pole 4 lamp
		// 		}
		// 	}
		// } else {
		// 	if (nfix === 0) {
		// 		poleImage = icPoleLamp0;///pole no lamp
		// 	} else if (nfix === 1) {
		// 		poleImage = icPoleLamp1;///pole 1 lamp
		// 	} else if (nfix === 2) {
		// 		poleImage = icPoleLamp2;///pole 2 lamp
		// 	} else if (nfix === 3) {
		// 		poleImage = icPoleLamp3;///pole 3 lamp
		// 	} else if (nfix > 3) {
		// 		poleImage = icPoleLamp4;///pole 4 lamp
		// 	}
		// }
		// return poleImage;

		// if (showWatts) {
		// 	if (wt > 0 && wt <= 20) {
		// 		// return mapStreetLightPink;
		// 		return lgt ? mapStreetLightTriangleShaded : mapStreetLightTriangle;
		// 	} else if (wt <= 70) {
		// 		// return mapStreetLightOrange;
		// 		return lgt ? mapStreetLightCircleShaded : mapStreetLightCircle;
		// 	} else if (wt > 70 /*120 /*wt <= 120*/) {
		// 		// return mapStreetLightGreen;
		// 		return lgt ? mapStreetLightDiamondShaded : mapStreetLightDiamond;
		// 	} else {
		// 		// return mapStreetLightBlue
		// 		return lgt ? mapStreetLightSquareShaded : mapStreetLightSquare;
		// 	}

		// } else {
		// 	if (statusCode === 1) {
		// 		return mapStreetLightOn;
		// 	} else {
		// 		return mapStreetLightOff;
		// 	}
		// }
	};
	const getLampImage = (pole) => {
		var poleImage = icPoleLamp1;
		const { slc_id: slc_id, nfix: nfix = 0, dev_st: status, is_slc: is_slc = false, dmy: dmy = false } = pole || {};
		if (status == true) {
			poleImage = ilmOn;///Green pole no lamp

		} else {
			poleImage = ilmOff;///Red pole no lamp
		}
		return poleImage;

	};

	const [mapCenter, setMapCenter] = useState(center);
	const getLatLng = (rowData) => {
		let degreeSymbol = "\u00B0";
		let result = "";
		let latitude = 0;
		let longitude = 0;
		let pole = null;
		if (rowData?.pid != undefined && rowData?.pid != null) {
			pole = PoleDataService.getInstance().getPole(rowData?.pid);
		}

		if (pole != null && pole?.loc != undefined && pole?.loc != null) {
			const {
				loc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {}
			} = pole;
			latitude = latitudeVal;
			longitude = longitudeVal;
		} else if (rowData?.lloc != undefined) {
			const {
				lloc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {}
			} = rowData;
			latitude = latitudeVal;
			longitude = longitudeVal;
		} else {
			const {
				loc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {}
			} = rowData;
			latitude = latitudeVal;
			longitude = longitudeVal;
		}


		if ((latitude === undefined | "") || (longitude === undefined | "")) {
			return "N/A"
		}
		if (latitude > 0) {
			result = `${latitude.toFixed(4)}${degreeSymbol}N`;
		} else {
			result = `${latitude.toFixed(4)}${degreeSymbol}S`;
		}
		if (longitude > 0) {
			result = `[${result}, ${longitude.toFixed(4)}${degreeSymbol}E]`;
		} else {
			result = `[${result}, ${longitude.toFixed(4)}${degreeSymbol}W]`;
		}
		return result;

	}
	const handleCenterChanged = () => {
		// const googleMmap = mapRef.current;
		if (map) {
			const center = map.getCenter();
			setMapCenter({
				lat: center.lat(),
				lng: center.lng(),
			});
		}
	};

	const overlayViewRef = React.useRef(null);

	const overlayViewContent = (
		<div
			style={{
				background: 'white',
				border: '1px solid #ccc',
				padding: 10,
				borderRadius: 5,
			}}
		>
			Overlay Content
		</div>
	);

	const overlayPosition = {
		lat: mapCenter.lat + 0.01, // Adjust latitude to position vertically
		lng: mapCenter.lng + 0.01, // Adjust longitude to position horizontally
	};

	const getPixelPositionOffset = (offsetWidth, offsetHeight, labelAnchor) => {
		return {
			x: offsetWidth + labelAnchor.x,
			y: offsetHeight + labelAnchor.y,
		};
	};

	// const downloadMap = async (slcId, lamps, zoomVal = "21") => {
	// 	// debugger;
	// 	let center = "";//"Eiffel Tower,Paris";
	// 	let mapType = "roadmap";
	// 	let visible = "";//48.85849004093204,2.294502763863771|48.84335670044386,2.360956251923224|48.85320764866506, 2.3428376983684824";
	// 	let scale = "1";
	// 	let zoom = zoomVal;
	// 	let size = "640x640";
	// 	let path = `color:0x0000ff|weight:5`;//|48.85849004093204,2.294502763863771|48.84335670044386,2.360956251923224|48.85320764866506, 2.3428376983684824`;
	// 	let markersString = "";
	// 	let clat = 0;
	// 	let clng = 0;
	// 	//     `color:red|label:E|48.85849004093204,2.294502763863771
	// 	//     color:blue|label:11|48.84335670044386,2.360956251923224
	// 	//     color:green|label:4|48.85320764866506, 2.3428376983684824`
	// 	// ;
	// 	const slcDevice = data.find((element) => element.uid == slcId);
	// 	if (slcDevice != null) {
	// 		let lat = 0;
	// 		let lng = 0;
	// 		let pole = null;

	// 		const {
	// 			loc: { _lat: devLat = 0, _long: devLng = 0 } = {},
	// 			uid: ccmsNumber = null,
	// 			dev_st = 0,
	// 			err_cnt = 0,
	// 			errors = [],
	// 		} = slcDevice || {};

	// 		if (slcDevice.pid != undefined && slcDevice.pid != null) {
	// 			pole = PoleDataService.getInstance().getPole(slcDevice.pid);
	// 		}

	// 		if (pole != null && pole.loc != undefined && pole.loc != null) {
	// 			const {
	// 				loc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {}
	// 			} = pole;
	// 			lat = latitudeVal;
	// 			lng = longitudeVal;
	// 		} else {

	// 			lat = devLat;
	// 			lng = devLng;
	// 		}
	// 		const position = {
	// 			lat,
	// 			lng,
	// 		};
	// 		if (lat != 0 && lng != 0) {
	// 			center = `${lat},${lng}`;
	// 			markersString = `color:red|label:S|${lat},${lng}`
	// 			visible = `${lat},${lng}`;

	// 			clat += lat;
	// 			clng += lng;
	// 		}
	// 	}

	// 	lamps.sort((a, b) => {
	// 		return a.lnum - b.lnum;
	// 	});

	// 	lamps.map((item, i) => {
	// 		const {
	// 			dev_id: ccmsNumber = null,
	// 			ilm_id: ilm_id = null,
	// 			lnum: lnum = 0,
	// 			dev_st = 0,
	// 			err_cnt = 0,
	// 			errors = [],
	// 			wt: wt = 0,
	// 		} = item || {};
	// 		let latitude = 0;
	// 		let longitude = 0;
	// 		let pole = null;
	// 		let poleNum = 0;
	// 		if (item.pid != undefined && item.pid != null) {
	// 			pole = PoleDataService.getInstance().getPole(item.pid);
	// 		}

	// 		if (pole != null && pole.loc != undefined && pole.loc != null) {
	// 			const {
	// 				pnum: pnum = 0,
	// 				loc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {}
	// 			} = pole;
	// 			poleNum = pnum;
	// 			latitude = latitudeVal;
	// 			longitude = longitudeVal;
	// 		} else if (item.lloc != undefined | null) {
	// 			const {
	// 				lloc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {}
	// 			} = item;
	// 			latitude = latitudeVal;
	// 			longitude = longitudeVal;
	// 		} else {
	// 			const {
	// 				loc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {}
	// 			} = item;
	// 			latitude = latitudeVal;
	// 			longitude = longitudeVal;
	// 		}

	// 		if ((latitude === undefined | "") || (longitude === undefined | "")) {
	// 			// return (null);
	// 		}
	// 		// const position = {
	// 		//   lat:latitude,
	// 		//   lng:longitude,
	// 		// };

	// 		// var label = `P${poleNum} / L${lnum}`;
	// 		console.log(`===> Lamp ${ccmsNumber}, [${latitude},${longitude}]`);

	// 		markersString = `${markersString}\ncolor:green|label:L|${latitude},${longitude}`;
	// 		visible = `${visible}|${latitude},${longitude}`;
	// 		path = `${path}|${latitude},${longitude}`;

	// 		clat += latitude;
	// 		clng += longitude;
	// 	});
	// 	// const [center, setCenter] = useState("Eiffel Tower,Paris");
	// 	//   const [mapType, setMapType] = useState("roadmap");
	// 	//   const [visible, setVisible] = useState("48.85849004093204,2.294502763863771|48.84335670044386,2.360956251923224|48.85320764866506, 2.3428376983684824");
	// 	//   const [scale, setScale] = useState("2");
	// 	//   const [zoom, setZoom] = useState("8");
	// 	//   const [size, setSize] = useState("640x640");
	// 	//   const [path, setPath] = useState(`color:0x0000ff|weight:5|48.85849004093204,2.294502763863771|48.84335670044386,2.360956251923224|48.85320764866506, 2.3428376983684824`);
	// 	//   const [markersString, setMarkersString] = useState(
	// 	//       `color:red|label:E|48.85849004093204,2.294502763863771
	// 	//       color:blue|label:11|48.84335670044386,2.360956251923224
	// 	//       color:green|label:4|48.85320764866506, 2.3428376983684824`
	// 	//   );

	// 	clat /= (lamps.length + 1);
	// 	clng /= (lamps.length + 1);

	// 	console.log(`Center ${center} -> ${clat},${clng}`);

	// 	center = `${clat},${clng}`;

	// 	const staticImageURL = generateStaticMapURL({
	// 		center,
	// 		mapType,
	// 		zoom,
	// 		size,
	// 		scale,
	// 		path,
	// 		visible,
	// 		markers: markersString
	// 			.split("\n")
	// 			.map(marker => marker.trim())
	// 			.filter(marker => marker.length > 0)
	// 	});

	// 	try {
	// 		const response = await axios.get(staticImageURL, {
	// 			responseType: 'arraybuffer',
	// 		});
	// 		const base64 = Buffer.from(response.data, 'binary').toString('base64');
	// 		const base64Image = `data:image/jpeg;base64,${base64}`;
	// 		setImageUrl(base64Image);
	// 	} catch (error) {
	// 		console.error('Error fetching the image:', error);
	// 	}
	// }

	// const onClickDownloadPDF = async () => {

	// 	let slcDetail = "";
	// 	let lamp20w = 0;
	// 	let lamp70w = 0;
	// 	let lamp120w = 0;
	// 	let lamp0w = 0;
	// 	const slcDevice = data.find((element) => element.uid == activeMarker);
	// 	if (slcDevice != null) {
	// 		let lat = 0;
	// 		let lng = 0;
	// 		let pole = null;
	// 		let addr = "";
	// 		let latitude = 0;
	// 		let longitude = 0;
	// 		let degreeSymbol = "\u00B0";
	// 		let result = "";

	// 		const {
	// 			loc: { _lat: devLat = 0, _long: devLng = 0 } = {},
	// 			lloc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {},
	// 			uid: ccmsNumber = null,
	// 			dev_id: dev_id = "",
	// 			pid: pid = null,
	// 			dev_st = 0,
	// 			err_cnt = 0,
	// 			errors = [],
	// 			ph_cnt: phaseCode = 0,
	// 			zn: zone = "",
	// 			wd: ward = "",
	// 			dmy: dummyPoles = 0,
	// 			tpoles: totalPoles = 0,
	// 			nfix: totalLamps = 0,
	// 			addr: address = "",
	// 			kw: kw = 0
	// 		} = slcDevice || {};

	// 		if (pid != undefined && pid != null) {
	// 			pole = PoleDataService.getInstance().getPole(pid);
	// 		}

	// 		if (pole != null && pole.addr != undefined && pole.addr != null) {
	// 			addr = pole.addr;
	// 		} else if (address != undefined | null | "") {
	// 			addr = address;
	// 		}

	// 		if (pole != null && pole.loc != undefined && pole.loc != null) {
	// 			const {
	// 				loc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {}
	// 			} = pole;
	// 			latitude = latitudeVal;
	// 			longitude = longitudeVal;
	// 		} else if (latitudeVal != 0 && longitudeVal != 0) {
	// 			latitude = latitudeVal;
	// 			longitude = longitudeVal;
	// 		} else {
	// 			latitude = devLat;
	// 			longitude = devLng;
	// 		}
	// 		if ((latitude === undefined | "") || (longitude === undefined | "")) {
	// 			// return "N/A"
	// 		}
	// 		if (latitude > 0) {
	// 			result = `${latitude}${degreeSymbol}N`;
	// 		} else {
	// 			result = `${latitude}${degreeSymbol}S`;
	// 		}
	// 		if (longitude > 0) {
	// 			result = `[${result}, ${longitude}${degreeSymbol}E]`;
	// 		} else {
	// 			result = `[${result}, ${longitude}${degreeSymbol}W]`;
	// 		}

	// 		slcDetail += `${dev_id} : ${devicePhaseCode[phaseCode]}\n\n`;
	// 		slcDetail += `Zone-${zone}, Ward-${ward}, ${addr}\n\n`;
	// 		slcDetail += `Geo Location: ${result}\n\n`;
	// 		slcDetail += `Total Poles: ${totalPoles}, Dummy Poles: ${dummyPoles}\n\n`;
	// 		slcDetail += `Total Lamps: ${totalLamps}\n\n`;
	// 		slcDetail += `Total KW: ${(kw)}\n\n`;
	// 	}

	// 	activeLamps.map((item, i) => {
	// 		const {
	// 			wt: wt = 0
	// 		} = item || {};

	// 		if (wt > 0 && wt <= 20) {
	// 			// return mapStreetLightPink;
	// 			// return lgt ? mapStreetLightTriangleShaded : mapStreetLightTriangle;
	// 			lamp20w = lamp20w + 1;
	// 		} else if (wt <= 70) {
	// 			// return mapStreetLightOrange;
	// 			// return lgt ? mapStreetLightCircleShaded : mapStreetLightCircle;
	// 			lamp70w = lamp70w + 1;
	// 		} else if (wt > 70 /*120 /*wt <= 120*/) {
	// 			// return mapStreetLightGreen;
	// 			// return lgt ? mapStreetLightDiamondShaded : mapStreetLightDiamond;
	// 			lamp120w = lamp120w + 1;
	// 		} else {
	// 			// return mapStreetLightBlue
	// 			// return lgt ? mapStreetLightSquareShaded : mapStreetLightSquare;
	// 			lamp0w = lamp0w + 1;
	// 		}
	// 	});

	// 	slcDetail += `20w- ${lamp20w}, 70w- ${lamp70w}, 120w- ${lamp120w}, old LED- ${lamp0w}`;
	// 	// SC1TAC10015: Single/Three Phase, Zone-1, Ward-17, Near School
	// 	// Geo Location: 10.11,17.53
	// 	// Total Poles: 10, Dummy Poles: 2
	// 	// Total Lamps: 20
	// 	// Total KW: 0.40 (wt/1000)
	// 	// 20w-10, 40W-6 with corrsponding images for each watts
	// 	// pdf.save(`SLC_${ccmsNumber}.pdf`);

	// 	// debugger;
	// 	const input = contentRef.current;
	// 	html2canvas(input)
	// 		.then((canvas) => {
	// 			const imgData = canvas.toDataURL('image/png');
	// 			const pdf = new jsPDF('p', 'mm', 'a4');
	// 			const imgProps = pdf.getImageProperties(imgData);
	// 			const pdfWidth = pdf.internal.pageSize.getWidth();
	// 			const pdfHeight = pdf.internal.pageSize.getHeight() * 0.3;
	// 			// const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
	// 			console.log(`Page size pdfWidth=${pdfWidth} | imgWidth=${imgProps.width} | imgHeight=${imgProps.height}`);
	// 			console.log(`Page size pdfWidth=${pdf.internal.pageSize.getWidth()} | pdfHeight=${pdf.internal.pageSize.getHeight()}`);
	// 			console.log(`Page size Output pdfWidth=${pdfWidth} | pdfHeight=${pdfHeight}`);

	// 			var xPos = pdfWidth / 4;
	// 			var yPos = 20;

	// 			var title = `${getHeaderDetail("city")} CITY MUNICIPAL CORPORATION`;
	// 			pdf.text(pdfWidth * 0.2, 10, title);

	// 			pdf.addImage(imgData, 'PNG', xPos, yPos, pdfWidth * 0.4, pdfHeight);
	// 			// pdf.addPage('a6','l');
	// 			pdf.text(20, yPos + pdfHeight + 20, slcDetail);
	// 			pdf.save(`SLC_${activeMarker}.pdf`);
	// 		})
	// 		.catch((error) => {
	// 			console.error('Error generating PDF:', error);
	// 		});
	// };

	//Get user Info
	const getHeaderDetail = (propName) => {
		let configResponse = localStorage.getItem("firebaseConfigApiResponse");
		let detail = "";
		if (configResponse) {
			configResponse = JSON.parse(configResponse);
			switch (propName) {
				case "email":
				default: {
					detail = localStorage.getItem("userEmail") || "";
					break;
				}
				case "city": {
					detail = configResponse?.displayName;
				}
			}
		}
		return detail;
	};

	const [filterObj, setFilterObj] = useState('slc');
	const [typeFilterList, setTypeFilterList] = useState([{ value: 'ilm', label: 'ILM' }, { value: 'slc', label: 'SLC' }]);
	const handleFilterChange = (e) => {
		const { target: { name = "", value = "" } = {} } = e;
		if (value === 'slc') {
			setActiveIlms([]);
			resetActiveMarker();
		}
		if (value === 'ilm') {
			resetActiveMarker();
			var ilmData = LampDataService.getInstance().getAllLamp();
			setActiveIlms(ilmData.ilmList)
		}
		setFilterObj(value);
		if (popupFlag.current == false) {
			const popupDiv = document.getElementById('popupDiv');
			const buttonDiv = document.getElementById('buttonDiv');

			map.controls[window.google.maps.ControlPosition.BLOCK_START_INLINE_END].pop(popupDiv);
			if (checkUserAccess("map_update"))
				map.controls[window.google.maps.ControlPosition.BLOCK_START_INLINE_END].pop(buttonDiv);
			popupFlag.current = true;
			setIlmInfoWindowFlag('')
			setInfoWindowFlag('')
		}
	};
	return isLoaded ? (
		<div className="dash-map-wrapper">
			<div className="dash-map-header">
				<div>
					<h3 className="dash-map-header-1"> Map View </h3>
					<div className="dash-map-header-2">CCMS Locations</div>
				</div>
				<div>
					<InputLabel id="zone-label" style={{ marginTop: "-10px", fontSize: '12.5px' }}>Device type</InputLabel>
					<FormControl
						size="small"
						variant="outlined"
						style={{
							minWidth: '100px',
							marginRight: '10px',
							backgroundColor: '#f5f5f5',
						}}
					>
						<Select
							size="small"
							labelId="zone-label"
							id="zone-outlined"
							name="zone"
							value={filterObj}
							onChange={handleFilterChange}
							label="Zone"
						>
							{typeFilterList.map((item) => (
								<MenuItem style={{ fontSize: '12.5px' }} key={item.value} value={item.value}>
									{item.label}
								</MenuItem>
							))}
						</Select>
					</FormControl>


					<Button
						variant="contained"
						className="dash-map-btn"
						onClick={handleToggleMap}
					>
						Show/Hide Map
					</Button>
					&nbsp;
					&nbsp;
					{popupFlag.current == false && filterObj === 'slc' && <Button
						variant="contained"
						className="dash-map-btn"
						// onClick={()=>{history.push("/slc-print")}}>
						//	onClick={()=>{<DashGoogleMapDownload></DashGoogleMapDownload>}}
						onClick={handleButtonClick}
					>
						Download Map PDF
					</Button>}

				</div>
			</div>

			<div style={{ position: 'absolute', top: '0px', left: '-1000px' }} >
				<div style={{ position: 'relative' }} ref={contentRef} id="imgMapRef">
					<img src={imageUrl} />
				</div>
			</div>
			<div className={`dash-map ${!toggleMap && "hide"}`}>

				<GoogleMap
					setOp
					ref={mapRef}
					mapContainerStyle={containerStyle}
					defaultZoom={10}
					// center={GOOGLE_MAP_CONFIG.center}
					// center={center}
					// zoom={zoom}
					onZoomChanged={onZoomChanged}
					onLoad={onLoad}
					onUnmount={onUnmount}
					onClick={onMapClick}
					onCenterChanged={handleCenterChanged}
					options={{
						disableDefaultUI: false,
						styles: [
							{
								featureType: 'poi',
								elementType: 'labels',
								stylers: [{ visibility: 'off' }]
							}
						]
					}}
					yesIWantToUseGoogleMapApiInternals
				>
					{/* poliline */}
					{slcLine.current?.data?.path?.map((arrItem, i) => {
						return (<Polyline
							onClick={(e) => {
								if (eraseFlag.current == true) {

									const selectedOuterArray = [...slcLine.current.data.path];

									selectedOuterArray.splice(i, 1);

									slcLine.current.data.path = [...selectedOuterArray];
									setRefresh((data) => { return !data; });
									// setPath(prevPath => {

									// 	const selectedOuterArray = [...prevPath];

									// 	selectedOuterArray.splice(i, 1);

									// 	return [...selectedOuterArray];
									// });
								}
							}}
							path={arrItem}
							options={{
								strokeColor: '#000000',
								strokeOpacity: 1.0,
								strokeWeight: 2.5,
							}}
						/>);
					})
					}
					{/* Add custom view here */}
					{/* <div
				style={{
				position: 'absolute',
				top: '10px',
				right: '70px',
				transform: 'translate(-50%, -50%)',
				backgroundColor: 'white',
				padding: '10px',
				borderRadius: '2px',
				boxShadow: '0px 0px 10px rgba(0,0,0,0.3)',
				zIndex: '2'
				}}
				>
				Custom View Over Map
				</div> */}
					{/* <OverlayView
					position={overlayPosition}
					mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
					getPixelPositionOffset={(width, height) => ({
						x: -width + 20, // 20px from right
					y: 20,          // 20px from top
					})}
					>
					<div ref={overlayViewRef}>
					{overlayViewContent}
					</div>
					</OverlayView> */}
					{/* SLC */}
					{filterObj === 'slc' && activeMarker === null && data.map((item, i) => {
						let lat = 0;
						let lng = 0;
						let pole = null;

						const {
							// loc: { _lat: devLat = 0, _long: devLng = 0 } = {},
							uid: ccmsNumber = null,
							dev_id: devId,
							wd: ward,
							zn: zone,
							dev_st = 0,
							err_cnt = 0,
							errors = [],
						} = item || {};

						// if (activeMarker != null) {
						// if (activeMarker != ccmsNumber) {
						// return null;
						// }
						// }

						if (item.pid != undefined && item.pid != null) {
							pole = PoleDataService.getInstance().getPole(item.pid);
						}

						if (pole != null && pole.loc != undefined && pole.loc != null) {
							const {
								loc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {}
							} = pole;
							lat = latitudeVal;
							lng = longitudeVal;
						}

						const position = { lat, lng, };

						if (lat == 0 || lng == 0) {
							return null;
						}
						// debugger;
						return (
							<Marker
								key={ccmsNumber}
								position={position}
								icon={{
									// url: redBulbImg,
									url: getMapImage(item),
									scaledSize: new window.google.maps.Size(30, 45),
								}}
								onClick={() => {
									if (popupFlag.current) {
										popupFlag.current = false;
										popUpMenu(map, ccmsNumber, errors, ward, zone, ccmsNumber);
										handleActiveMarker(ccmsNumber);
										setCenter(position);
									}
								}}
							>
								{/* {activeMarker === ccmsNumber ? (
								<InfoWindow
								position={{
								lat,
								lng,
								}}
								onCloseClick={() => resetActiveMarker()}
								>
								<div>
								<div>
								<strong>UID:</strong> {ccmsNumber}
								</div>
								<div>
								<strong>Status:</strong> {getDeviceStatus(ccmsNumber)}
								</div>
								<div style={{ marginLeft: "-15px" }}>
								
								<FormControlLabel
								labelPlacement="start"
								control={
								<Switch defaultChecked
								checked={showWatts}
								onChange={handleShowWattsChange}
								size="small" />
								}
								label="Lamp Watts" />
								
								</div>
								{/* <div>
								<Switch  label="show lamp Watts" size="small" defaultChecked />
								<Switch value="checkedA" inputProps={{ 'aria-label': 'Switch A' }} />
								
								</div> * /}
								{errors.length ? (
								<div>
								<strong>Errors:</strong>
								<div>
								{errors.map((errCode) => {
									return (
								<div>{deviceErrorEventCode[errCode]}</div>
								);
								})}
								</div>
								</div>
								) : null}
								</div>
								</InfoWindow>
								) : null} */}
							</Marker>
						);
					})}

					{/* poles */}
					{activeMarker != null && activePoles.map((pole, i) => {
						const {
							uid: uid = "",
							dev_id: dev_id = "",
							slc_id: slc_id = "",
							zn: zone = '',
							addr: location = '',
							nfix: totalLamps = '',
							pnum: pnum = 0,
							is_slc: is_slc = 0,
							nfix: nfix = 0,
							wd: ward,
							// loc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = { _lat: 0, _long: 0 },
						} = pole || {};
						var poleNum = pnum;
						var latitude = pole?.loc?.latitude ?? 0;
						var longitude = pole?.loc?.longitude ?? 0;
						// var latitude = latitudeVal;
						// var longitude = longitudeVal;


						if ((latitude === undefined | "" | 0) || (longitude === undefined | "" | 0)) {
							return (null);
						}

						// var m_pos = poleMarkerPosition[uid];
						var m_pos = poleMarkerPosition.current[uid];

						if (m_pos != undefined) {
							latitude = m_pos.lat;
							longitude = m_pos.lng;
						}
						const position = {
							lat: latitude,
							lng: longitude,
						};
						if (uid === null || uid === undefined || uid === '') {
							return
						}
						// const  = DeviceDataService.getInstance().getDeviceByPID(slc_id);

						const device = LampDataService.getInstance().getLampByPid(pole['uid']); //get lapm watts 
						// console.log(JSON.stringify(device))
						
						const {
							dev_id: UID = '',
 							dev_st: status = '',
							ph_cnt: phase = '',
							ilm_id: ilm_id = "",
							ilm: ilm = false,
							wt: wt = "",

						} = device ?? {};
						//Get all lamps in the pole
						const lamps = LampDataService.getInstance().getLampsWattsByPid(pole['uid']).deviceList; //get lapm watts 
						var wattsObj = {};
						for (var lamp of lamps) {
							var wattCount = wattsObj[lamp] ?? 0;
							wattCount = wattCount + 1;
							wattsObj[lamp] = wattCount;

						}
						var wattsStr = "";

						for (const key in wattsObj) {

							var seprator = ",";
							if (wattsStr == "") {
								seprator = "";
							}
							if (key == 0) {
								wattsStr = `Oldx${wattsObj[key]}`;
							} else {
								wattsStr = `${wattsStr}${seprator}${key}x${wattsObj[key]}`;
							}

						}
 						//var label = `P${poleNum} / L${nfix}`;
						var label = `${poleNum}/${wattsStr}`;
						if (wattsStr == "") {
							label = `${poleNum}`;
						}

						// console.log(`===> Lamp ${uid}, [${latitude},${longitude}]`);
						return (
							<Marker
								key={uid}
								position={position}
								draggable={moveLampFlag.current}
								onDragEnd={(event) => {
									poleMarkerPosition.current[uid] = {
										lat: event.latLng.lat(),
										lng: event.latLng.lng(),
									};

									// 	setPoleMarkerPosition((current) => {
									// 		return {
									// 	  ...current,
									// 	  [uid]:{
									// 		lat: event.latLng.lat(),
									// 		lng: event.latLng.lng(),
									// 	  },}
									// });
								}}
								// label={label}
								icon={{
									// url: redBulbImg,
									url: getPoleImage(pole),
									scaledSize: new window.google.maps.Size(30, 30),
								}}
								//pole click
								onMouseOver={() => {
									// alert(JSON.stringify(pole))
									// return
									poleWatts.current = wattsStr;
									setInfoWindowFlag(pole.uid);
									if (drawFlag.current) {
										drawMap(position);
									}

								}}
							>
								<OverlayView
									key='mwl'
									position={position}
									mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
								// getPixelPositionOffset={(x, y) => getPixelPositionOffset(x, y, { x: -45, y: -30 })}
								>
									<div style={{
										background: `#203254`,
										padding: `3px 8px 3px 3px`,
										fontSize: '12px',
										color: `white`,
										borderRadius: '4px',
									}}>
										<text
											style={{
												background: `#203254`,
												padding: `3px 3px 3px 3px`,
												fontSize: '12px',
												color: `white`,
												borderRadius: '4px',
											}}
										>
											{label}
										</text>
									</div>
								</OverlayView>
								{infoWindowFlag == uid && (
									<div>
										<InfoWindow
											position={position}
											onCloseClick={() => { setInfoWindowFlag("") }}
										>
											{is_slc ? (<div style={{
												fontSize: '12px',
											}}>
												{/* <div>UID: {activeMarker} </div> */}
												<div>Status: {getDeviceStatus(slc_id)} </div>
												<div>Ward: {ward} </div>
												<div>Zone: {zone} </div>
												<div>Location: {location} </div>
												<div>GPS Location: {getLatLng(pole)} </div>
												{/* <div>Phase: {phase} </div> */}
												<div>Total lamps: {nfix} </div>
												{(poleWatts.current != "") && (<div>pole watts: {poleWatts.current}</div>)}
												{/* <div>Pole ward: {ward}</div> */}
											</div>) :
												<div style={{
													fontSize: '12px',
												}}>
													<div>UID:{UID ? UID : uid} </div>
													<div>Status :{deviceStatusCode[status]} </div>
													<div>Watts :{wt} </div>
													<div>ILM :{ilm_id ? ilm_id : "N/A"} </div>
													<div>Ward :{ward} </div>
													<div>Zone :{zone} </div>
													<div>Location :{location} </div>
													<div>GPS Location :{getLatLng(pole)} </div>

												</div>

											}
										</InfoWindow>
									</div>)}
							</Marker>
						);
					})}
					{activeIlm.map((pole, i) => {
						const {
							pid: pid = "",
							dev_id: dev_id = "",
							slc_id: slc_id = "",
							zn: zone = '',
							addr: location = '',
							nfix: totalLamps = '',
							pnum: pnum = 0,
							ilm: ilm = 0,
							ilm_id: ilm_id = 0,
							nfix: nfix = 0,
							dev_st: status = '',
							wd: ward,
							loc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {}
						} = pole;
						var poleNum = pnum;
						var latitude = latitudeVal;

						var longitude = longitudeVal;
						let poleData;
						if (pid != undefined && pid != null) {
							poleData = PoleDataService.getInstance().getPole(pid);
						}

						if (poleData != null && poleData?.loc != undefined && poleData?.loc != null) {
							const {
								loc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {}
							} = poleData;
							latitude = latitudeVal;
							longitude = longitudeVal;
						}

						if ((latitude === undefined | "" | 0) || (longitude === undefined | "" | 0)) {
							return (null);
						}
						// var m_pos = poleMarkerPosition[uid];
						// var m_pos = poleMarkerPosition.current[pid];

						// if (m_pos != undefined) {
						// 	latitude = m_pos.lat;
						// 	longitude = m_pos.lng;
						// }
						const position = {
							lat: latitude,
							lng: longitude,
						};

						if (pid === null || pid === undefined || pid === '') {
							return
						}
						// const device = LampDataService.getInstance().getLampByPid(pole['uid']); //get lapm watts 
						// console.log(JSON.stringify(device))
						// const {
						// 	dev_id: UID = '',
						// 	dev_st: status = '',
						// 	ph_cnt: phase = '',
						// 	ilm_id: ilm_id = "",
						// 	ilm: ilm = false,
						// 	wt: wt = "",

						// } = device ?? {};
						// //Get all lamps in the pole
						// const lamps = LampDataService.getInstance().getLampsWattsByPid(pole['uid']).deviceList; //get lapm watts 
						// var wattsObj = {};
						// for (var lamp of lamps) {
						// 	var wattCount = wattsObj[lamp] ?? 0;
						// 	wattCount = wattCount + 1;
						// 	wattsObj[lamp] = wattCount;

						// }
						// var wattsStr = "";

						// for (const key in wattsObj) {

						// 	var seprator = ",";
						// 	if (wattsStr == "") {
						// 		seprator = "";
						// 	}
						// 	wattsStr = `${wattsStr}${seprator}${key}x${wattsObj[key]}`;

						// }
						// //var label = `P${poleNum} / L${nfix}`;
						// var label = `${poleNum}/${wattsStr}`;
						// if (wattsStr == "") {
						// 	label = `${poleNum}`;
						// }

						return (
							<Marker
								key={pid}
								position={position}
								draggable={moveLampFlag.current}
								icon={{
									// url: redBulbImg,
									url: getLampImage(pole),
									scaledSize: new window.google.maps.Size(30, 30),
								}}
								//pole click
								onClick={() => {
									// poleWatts.current = wattsStr;
									setIlmInfoWindowFlag(pole.pid);
									if (popupFlag.current) {
										popupFlag.current = false;
										popUpMenu(map, dev_id, [], ward, zone, dev_id);
										if (drawFlag.current) {
											drawMap(position);
										}
									}
								}}>

								{ilmInfoWindowFlag == pid && (
									<div>
										<InfoWindow
											position={position}
											onCloseClick={() => { setIlmInfoWindowFlag("") }}
										>
											<div style={{
												fontSize: '12px',
											}}>
												<div>Status: {deviceStatusCode[status]} </div>
												<div>Ward: {ward} </div>
												<div>Zone: {zone} </div>
												<div>Location: {location} </div>
												<div>GPS Location: {getLatLng(pole)} </div>
											</div>
										</InfoWindow>
									</div>)}
							</Marker>
						);
					})}



					{/* Lamp */}
					{/* {activeLamps.map((item, i) => {
									const {
									dev_id: ccmsNumber = null,
									ilm_id: ilm_id = null,
									lnum: lnum = 0,
									dev_st = 0,
									err_cnt = 0,
									errors = [],
									} = item || {};
									let latitude = 0;
									let longitude = 0;
									let pole = null;
									let poleNum = 0;
									if (item.pid != undefined && item.pid != null) {
									pole = PoleDataService.getInstance().getPole(item.pid);
									}
									
									if (pole != null && pole.loc != undefined && pole.loc != null) {
									const {
									pnum: pnum = 0,
									loc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {}
									} = pole;
									poleNum = pnum;
									latitude = latitudeVal;
									longitude = longitudeVal;
									} else if (item.lloc != undefined | null) {
									const {
									lloc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {}
									} = item;
									latitude = latitudeVal;
									longitude = longitudeVal;
									} else {
									const {
									loc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {}
									} = item;
									latitude = latitudeVal;
									longitude = longitudeVal;
									}
									
									if ((latitude === undefined | "") || (longitude === undefined | "")) {
									return (null);
									}
									//console.log(JSON.stringify(LampMarkerPosition));
									var m_pos = LampMarkerPosition[ccmsNumber];
									if(m_pos != undefined ){
									latitude = m_pos.lat;
									longitude = m_pos.lng;
									}
									const position = {
									lat: latitude,
									lng: longitude,
									};
									// 			if(markerPosition.current != null){
									
									//   position = {lat : markerPosition.current.latLng.lat(),lng : markerPosition.current.latLng.lng()};	 
									// 			}
									
									var label = `P${poleNum} / L${lnum}`;
									console.log(`===> Lamp ${ccmsNumber}, [${latitude},${longitude}]`);
									return (
									<Marker
									key={ccmsNumber}
									position={position}
									draggable={moveLampFlag.current}
									onDragEnd={(event) => {
										setLampMarkerPosition((current) => {
											return {
									...current,
									[ccmsNumber]:{
									lat: event.latLng.lat(),
									lng: event.latLng.lng(),
									},}
									});
									}}
									// label={label}
									icon={{
									// url: redBulbImg,
									url: getLampImage(item),
									scaledSize: new window.google.maps.Size(30, 30),
									}}
									onClick={() => {alert(JSON.stringify(position)) }}>
									
									<OverlayView
									key='mwl'
									position={position}
									mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
									getPixelPositionOffset={(x, y) => getPixelPositionOffset(x, y, { x: -40, y: -40 })}>
									<div
									style={{
									background: `#203254`,
									padding: `7px 12px`,
									fontSize: '11px',
									color: `white`,
									borderRadius: '4px',
									}}
									>
									{label}
									<div>
									{ilm_id ?? ""}
									</div>
									</div>
									</OverlayView>
									{/* <InfoWindow
									position={position}
									// onCloseClick={() => resetActiveMarker()}
									>
									<div>
									<div>
									<strong>UID:</strong> {ccmsNumber}
									</div>
									{/* <div>
									<strong>Status:</strong> {getDeviceStatus(ccmsNumber)}
									</div> * /}
									</div>
									</InfoWindow> * /}
									</Marker>
									);
									})} */}

				</GoogleMap>
				{/* Add custom view here */}
				{/* <div
										style={{
										position: 'absolute',
										top: '10px',
										right: '70px',
										transform: 'translate(-50%, -50%)',
										backgroundColor: 'white',
										padding: '10px',
										borderRadius: '2px',
										boxShadow: '0px 0px 10px rgba(0,0,0,0.3)',
										zIndex: '200'
										}}
										>
										Custom View Over Map outside
										</div> */}
			</div>
		</div>
	) : (
		<></>
	);
};

export default memo(DashGoogleMap);